import * as axios from 'axios';

const url = `${process.env.VUE_APP_API_URL}/user`;

export function setHourlyRate(userId: string, rate: number) {
    return axios.default.put(`${url}/${userId}/hourlyRate`, { data: rate });
}